import "./SearchWasher.css";
import "./ResponsiveSearchWasher.css";
import useSearchWasher from "./useSearchWasher";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import LaundryModal from "../LaundryModal/LaundryModal.js";
import { getTranslatedText as translate } from "../../Localization/Translation";

const SearchWasher = () => {
  const {
    locale,
    AllCities,
    LaundCards,
    show,

    // functions
    handleClose,
    selectCityChange,
    searchBoxChange,
    selectSortChange,
  } = useSearchWasher();

  return (
    <div
      className="SearchWasher-component"
      dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
    >
      <div className="SearchWasher">
        {/* <!-- Actual search box --> */}
        <div
          className="form-group has-search "
          dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
        >
          <i className="bi bi-search form-control-feedback"></i>
          <input
            type="text"
            className="form-control search-washer-input-placeholder"
            placeholder={translate("Search-box-placeholder", locale)}
            onChange={searchBoxChange}
          />
        </div>

        {/* <!-- Filter --> */}
        <div className="filter-box-search-washer ">
          {/* Newest Filter */}
          <select
            className="selectFilter"
            name="filter"
            onChange={selectSortChange}
          >
            <option className="optionsMenu" value="sort-starting-with">
              {translate("sort-starting-with", locale)}
            </option>
            <option className="optionsMenu" value="more-to-less">
              {translate("rate-max-to-min", locale)}
            </option>
            <option className="optionsMenu" value="less-to-more">
              {translate("rate-min-to-max", locale)}
            </option>
          </select>
          {/* City Filter */}
          <select
            className="selectFilter"
            name="filter"
            onChange={selectCityChange}
          >
            <option className="optionsMenu" value="choose-city">
              {translate("choose-city", locale)}
            </option>
            {AllCities.map((city) => {
              return (
                <option key={city.id} value={city.name}>
                  {city.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="Launds-search-list row">{LaundCards}</div>

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Body>
          <LaundryModal />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button
            variant="primary"
            className="btn btn-calendar-modal-save"
            onClick={handleClose}
          >
            {translate("modal-ok-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SearchWasher;
